'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.category = category;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function category() {
    var clazz = function Category() {
        var defaults = {
            id: 0,
            name: '',
            parentCategoryId: null,
            parents: []
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var category = new clazz();
        category.id = resource.id;
        category.name = resource.name;
        category.parentCategoryId = resource.parentCategoryId;
        category.parents = resource.parents;
        return category;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/categoryModel.js
// module id = 737
// module chunks = 0